import DeleteUser from "../DeleteUser/DeleteUser";
import BuzzcomHome from "../Pages/BuzzCom/BuzzcomHome";
import MessageScreen from "../Pages/BuzzCom/Messages";
import DeleteAccountVerification from "../Pages/DeleteAccountVerification/DeleteAccountVerification";

export const DashboardRoutes = [
  {
    path: "/buzzcom",
    component: MessageScreen,
    private: true,
    exact: true,
  },
  {
    path: "/delete_account",
    component: DeleteUser,
    private: true,
    exact: true,
  },
  {
    path: "/deleteaccountotp/:email",
    component: DeleteAccountVerification,
    private: true,
    exact: true,
  },
  {
    path: "/",
    component: BuzzcomHome,
    private: false,
    exact: true,
  },
];
